// Auto-generated by sol2ts transpiler
// Do not edit manually

import { Contract, Storage, ADDRESS_ZERO, sha256, sha256String, addressToUint, blockhash, ecrecover, selfdestruct } from './runtime';

export enum Type {
  Yin = 0,
  Yang = 1,
  Earth = 2,
  Liquid = 3,
  Fire = 4,
  Metal = 5,
  Ice = 6,
  Nature = 7,
  Lightning = 8,
  Faith = 9,
  Air = 10,
  Math = 11,
  Cyber = 12,
  Cosmic = 13,
  None = 14,
}

export enum GameStatus {
  Started = 0,
  Ended = 1,
}

export enum EffectStep {
  OnApply = 0,
  RoundStart = 1,
  RoundEnd = 2,
  OnRemove = 3,
  OnMonSwitchIn = 4,
  OnMonSwitchOut = 5,
  AfterDamage = 6,
  AfterMove = 7,
  OnUpdateMonState = 8,
  PreDamage = 9,
}

export enum MoveClass {
  Physical = 0,
  Special = 1,
  Self = 2,
  Other = 3,
}

export enum MonStateIndexName {
  Hp = 0,
  Stamina = 1,
  Speed = 2,
  Attack = 3,
  Defense = 4,
  SpecialAttack = 5,
  SpecialDefense = 6,
  IsKnockedOut = 7,
  ShouldSkipTurn = 8,
  Type1 = 9,
  Type2 = 10,
}

export enum EffectRunCondition {
  SkipIfGameOver = 0,
  SkipIfGameOverOrMonKO = 1,
}

export enum StatBoostType {
  Multiply = 0,
  Divide = 1,
}

export enum StatBoostFlag {
  Temp = 0,
  Perm = 1,
}

export enum EngineHookStep {
  OnBattleStart = 0,
  OnRoundStart = 1,
  OnRoundEnd = 2,
  OnBattleEnd = 3,
}
